import { render, staticRenderFns } from "./DoorDetail.vue?vue&type=template&id=dae60dfc"
import script from "./DoorDetail.vue?vue&type=script&lang=js"
export * from "./DoorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports